import React, { useState, useEffect, FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import MediumClear from 'crehana-icons/MediumClear';
import Text from 'crehana-ui/Text';
import { breakpoints } from 'crehana-ui/styles/breakpoints';

import useCollapse from 'Jsx/Shared/Hooks/useCollapse';

import customLocalStorage from 'Utils/customLocalStorage';

const Container = styled.div`
  background-color: #f6f4fe;
  border: 1px solid #6f4ef6;
  box-sizing: border-box;
  z-index: 1000;
`;

const TextStyled = styled(Text)`
  font-size: 8px !important;
  ${breakpoints.up('md')} {
    font-size: 11px !important;
  }
`;

const localStorageKeyIdentifier = 'BottomBannerStatus_MembershipGift';

const GiftMembershipReminder: FC = () => {
  const { t } = useTranslation();
  const [giftMembershipDeliveryData, setGiftMembershipDeliveryData] = useState<
    | {
        daysLeftToExpire: number;
        giftFormUrl: string;
      }
    | undefined
  >(undefined);

  const { toggleOpen, getCollapseProps } = useCollapse({
    defaultOpen: false,
  });

  useEffect(() => {
    setTimeout(() => {
      if (
        window.__INITIAL_STATE__?.giftMembershipDeliveryData &&
        customLocalStorage.getItem(localStorageKeyIdentifier) !== 'closed'
      ) {
        setGiftMembershipDeliveryData(
          window.__INITIAL_STATE__.giftMembershipDeliveryData,
        );
        toggleOpen();
      }
    }, 1000);
  }, []);

  if (!giftMembershipDeliveryData) {
    return null;
  }

  if (giftMembershipDeliveryData.daysLeftToExpire === 0) {
    return null;
  }

  const onClickBanner = () => {
    customLocalStorage.setItem(localStorageKeyIdentifier, 'closed');
    window.location.href = giftMembershipDeliveryData.giftFormUrl;
  };

  const closeBanner = e => {
    // We don't want the click is propagated to the Banner Root itself because if so it will run the onClickBanner handler
    e.stopPropagation();
    customLocalStorage.setItem(localStorageKeyIdentifier, 'closed');

    toggleOpen();
  };

  const message = {
    mobile: t('GIFT_MEMBERSHIP_MOBILE', {
      defaultValue:
        '¡Te quedan {{days}} días para regalar una membresía anual!',
      days: giftMembershipDeliveryData.daysLeftToExpire,
    }),
    desktop: t('GIFT_MEMBERSHIP_DESKTOP', {
      defaultValue:
        'Te quedan {{days}} dias para regalar una membresía anual a quién tú quieras! ENVIAR REGALO',
      days: giftMembershipDeliveryData.daysLeftToExpire,
    }),
  };

  return (
    <div className="cursor-pointer" {...getCollapseProps()}>
      <Container
        className="relative z-1 flex items-center justify-center h-48 w-full pr-48 md:pr-0"
        onClick={onClickBanner}
      >
        <TextStyled
          type="label"
          className="text-11 text-center"
          color="primary-light"
        >
          <span className="hidden md:block">{message.desktop}</span>
          <span className="block md:hidden">{message.mobile}</span>
        </TextStyled>
        <button
          type="button"
          className="top-0 right-0 absolute z-2 w-48 h-48 flex items-center justify-center"
          onClick={closeBanner}
        >
          <MediumClear size={12} color="#4B22F4" />
        </button>
      </Container>
    </div>
  );
};

export default GiftMembershipReminder;
